import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button, Input, PersonPicker } from '../../../../components'
import { useMessage, useModalDialog } from '../../../../hooks'
import { useClientCaseDialog } from '../../hooks'
import { clientContactService } from '../../services'

// Kontakter tab — role-qualified engagement contacts for a client. New person
// creation goes through the shared PersonPicker's own modal (identifier
// required), then this just POSTs the {client, person_uuid, role} link row.
export const ClientContacts = ({ clientSlug }) => {
  const { showMessage } = useMessage()
  const { hideModalDialog } = useModalDialog()
  const { showRemoveContactDialog } = useClientCaseDialog()

  const [contacts, setContacts] = useState([])
  const [loading, setLoading]   = useState(true)
  const [personUuid, setPersonUuid] = useState('')
  const [role, setRole]         = useState('')
  const [adding, setAdding]     = useState(false)

  const fetchContacts = () => {
    setLoading(true)
    clientContactService.getByClient(clientSlug)
      .then(res => { setContacts(res.clientContacts || []); setLoading(false) })
      .catch(() => { showMessage('Kunde inte ladda kontakter', 'error'); setLoading(false) })
  }

  useEffect(() => { fetchContacts() }, [clientSlug]) // eslint-disable-line react-hooks/exhaustive-deps

  const addContact = () => {
    if (!personUuid) return
    setAdding(true)
    clientContactService.create({ client: clientSlug, person_uuid: personUuid, role: role || undefined })
      .then(() => { setPersonUuid(''); setRole(''); fetchContacts() })
      .catch(err => showMessage(err.message || 'Kunde inte lägga till kontakt', 'error'))
      .finally(() => setAdding(false))
  }

  const removeContact = (contact) => {
    showRemoveContactDialog(contact, async () => {
      await clientContactService.remove(contact.client_contact_id)
        .then(() => { hideModalDialog(); showMessage('Borttagen'); fetchContacts() })
        .catch(err => showMessage(err.message || 'Kunde inte ta bort', 'error'))
    })
  }

  if (loading) return <p style={{ color: 'var(--color-dark-grey)' }}>Laddar…</p>

  return (
    <div>
      {contacts.length === 0
        ? <p style={{ color: 'var(--color-dark-grey)', fontStyle: 'italic' }}>Inga kontakter ännu.</p>
        : (
          <table className="cc-table">
            <thead><tr><th>Namn</th><th>Roll</th><th>E-post</th><th>Titel</th><th></th></tr></thead>
            <tbody>
              {contacts.map(c => (
                <tr key={c.client_contact_id}>
                  <td><Link className="link" to={`/network/persons/${c.client_contact_person_uuid}`}>{c.person_name}</Link></td>
                  <td>{c.client_contact_role || '—'}</td>
                  <td style={{ color: 'var(--color-dark-grey)' }}>{c.person_email || '—'}</td>
                  <td style={{ color: 'var(--color-dark-grey)' }}>{c.person_title || '—'}</td>
                  <td><button className="button-icon" title="Ta bort" onClick={() => removeContact(c)}>✕</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      }

      <div className="cc-row" style={{ marginTop: 20, alignItems: 'flex-end' }}>
        <div className="form-block" style={{ flex: 2 }}>
          <PersonPicker name="person_uuid" label="Lägg till kontakt" value={personUuid} onChange={({ value }) => setPersonUuid(value)} allowCreate />
        </div>
        <div className="form-block">
          <label>Roll</label>
          <Input name="role" placeholder="t.ex. Beställare" value={role} onChange={e => setRole(e.target.value)} />
        </div>
        <Button value={adding ? 'Lägger till…' : '+ Lägg till'} className="button" onClick={addContact} disabled={!personUuid || adding} />
      </div>
    </div>
  )
}
